export default __webpack_public_path__ + "static/media/hairstyle.95de3e36.svg";